<template>
  <div class="d-flex align-center">
    <b-button icon="x-octagon-fill" @click="init()" variant="primary">
      View</b-button
    >
    <b-modal
      tabindex="0"
      v-model="dialog"
      title="Update Organ Assessment Details"
      hide-footer
      scrollable
      ignore-enforce-focus-selector=".select2-search__field"
      size="md"
      centered
    >
      <div class="d-flex align-items-center">
        <b-row>
          <b-col cols="12" md="6">
            <input-field
              label="Evaluation By"
              :disabled="true"
              rules="required"
              v-model="form.inspection_by"
            ></input-field>
          </b-col>
          <b-col cols="12" md="6">
            <input-field
              label="Evaluation Notes"
              rules="required"
              :disabled="true"
              v-model="form.inspection_note"
            ></input-field>
          </b-col>
          <b-col cols="12" md="6">
            <input-field
              label="Reason"
              :disabled="true"
              v-model="form.reason"
            ></input-field>
          </b-col>
          <b-col cols="12" md="6" v-if="form.inspection_file_1">
            <file-input-group
              label="Photo Upload 1"
              accept=".jpg,capture=camera,.jpeg,.png,.pdf"
              rules="file-image-pdf|file-size"
              :disabled="true"
              v-model="form.inspection_file_1"
            ></file-input-group>
          </b-col>
          <b-col cols="12" md="6" v-if="form.inspection_file_2">
            <file-input-group
              label="Photo Upload 2"
              accept=".jpg,capture=camera,.jpeg,.png,.pdf"
              rules="file-image-pdf|file-size"
              :disabled="true"
              v-model="form.inspection_file_2"
            ></file-input-group>
          </b-col>
          <b-col cols="12" md="6" v-if="form.inspection_file_3">
            <file-input-group
              label="Cross Match"
              accept=".jpg,capture=camera,.jpeg,.png,.pdf"
              rules="file-image-pdf|file-size"
              :disabled="true"
              v-model="form.inspection_file_3"
            ></file-input-group>
          </b-col>
          <b-col cols="12" md="6" v-if="form.inspection_file_4">
            <file-input-group
              label="Liver Biopsy"
              accept=".jpg,capture=camera,.jpeg,.png,.pdf"
              :disabled="true"
              rules="file-image-pdf|file-size"
              v-model="form.inspection_file_4"
            ></file-input-group>
          </b-col>
          <b-col cols="12" md="6" v-if="form.inspection_file_5">
            <file-input-group
              label="Pulmonary Function Test"
              accept=".jpg,capture=camera,.jpeg,.png,.pdf"
              rules="file-image-pdf|file-size"
              :disabled="true"
              v-model="form.inspection_file_5"
            ></file-input-group>
          </b-col>
          <b-col cols="12" md="6" v-if="form.inspection_file_6">
            <file-input-group
              label="Echo/TEE"
              accept=".jpg,capture=camera,.jpeg,.png,.pdf"
              :disabled="true"
              rules="file-image-pdf|file-size"
              v-model="form.inspection_file_6"
            ></file-input-group>
          </b-col>
        </b-row>
      </div>
      <div class="d-flex mt-3">
        <div class="flex-grow-1"></div>
        <b-button variant="outline-danger" @click="dialog = false"
          >Cancel
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { isDocObject, openFile } from "../../../../../assets/js/common";
import donorService from "../../../../../assets/services/donor.service";
import FileInputGroup from "../../../../form/FileInputGroup.vue";
import InputField from "../../../../form/InputField.vue";
export default {
  components: { InputField, FileInputGroup },
  props: {
    recipeint: {
      type: Object,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      dialog: false,
      form: {
        reason: "",
        inspection_by: "",
        inspection_note: "",
        inspection_file_1: "",
        inspection_file_2: "",
        inspection_file_3: "",
        inspection_file_4: "",
        inspection_file_5: "",
        inspection_file_6: "",
      },
      list: [],
    };
  },
  computed: {
    fields() {
      let doc = {
        first_name: "Name",
        phone_number_1: "Phone Number",
        photo: "View Transport Details",
        action: "Allocation Status",
      };
      let list = [];
      Object.keys(doc).forEach((key) => {
        list.push({
          key,
          label: doc[key],
        });
      });
      return list;
    },
  },
  methods: {
    open(file) {
      openFile(file);
    },
    async init() {
      const vm = this;
      let { recepeint_allocation_id } = vm.recipeint;
      const doc = {
        dml_indicator: "S",
        recepeint_allocation_id,
      };
      try {
        vm.list = [];
        vm.$loader.show();
        let { data } = await donorService.organInspectionList(doc);
        let { list, status, msg } = data;
        vm.isLoading = false;
        vm.$loader.hide();
        if (!status) return vm.$alert.show(msg);
        if (isDocObject(list)) {
          let doc = list[0];
          Object.keys(vm.form).forEach((key) => {
            if (doc[key]) vm.form[key] = doc[key];
          });
        }
        vm.dialog = true;
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
  },
};
</script>

<style></style>
